import { useState, useEffect } from 'react';

type Dimensions = {
  width: number;
  height: number;
};

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;

  return { width, height } as Dimensions;
};

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState<Dimensions>(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};

export default useWindowDimensions;
